import { authorizedApiRequest, queryParameters, addLanguageAndTimezone } from '../setup/ApiService'

export default {
  all,
  query,
  createOrUpdate,
  delete: _delete,
}

function query(params) {
  return authorizedApiRequest(
    '/insurers?' + queryParameters(params), //
    'GET',
  )
}

function all(params) {
  return authorizedApiRequest(
    '/insurers/all', //
    'GET',
  )
}

function createOrUpdate(insurer) {
  return authorizedApiRequest(
    `/insurers/${insurer.id}`, //
    'PUT',
    addLanguageAndTimezone(insurer),
  )
}

// prefixed function name with underscore because delete is a reserved word in javascript
function _delete(id) {
  return authorizedApiRequest(
    `/insurers/${id}`, //
    'DELETE',
  )
}
